import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import {
    Box,
    IconButton,
    Card,
    CardMedia,
    CardContent,
    Chip,
    Paper,
    Avatar,
    Button,
    Divider,
    Grid
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LaunchIcon from '@mui/icons-material/Launch';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import './ScheduledPopup.css';
import { showToast } from "../../Toast/CommonToast";



const ScheduledPopup = ({ open, onClose, scheduledData }: any) => {

    React.useEffect(() => {
        if (scheduledData && scheduledData.length > 0) {
            showToast(`${scheduledData.length} Scheduled Videos Published Successfully`, 'success');
            scheduledData.forEach((item: any) => {
                showToast(`${item.title} Scheduled Video Published Successfully`, 'success');
            });
        }
    }, [scheduledData]);

    const getStatusColor = (status: string) => {
        switch (status.toLowerCase()) {
            case 'published':
                return 'success';
            case 'draft':
                return 'warning';
            case 'private':
                return 'error';
            default:
                return 'default';
        }
    };

    const handleYouTubeClick = (url: string) => {
        window.open(url, '_blank');
    };

    // Determine Paper style based on scheduledData length
    const paperStyle =
        scheduledData && scheduledData.length === 1
            ? { style: { width: 'max-content', minWidth: 350 } }
            : {};

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            }}
            className="youtubePopup"
            maxWidth={scheduledData && scheduledData.length === 1 ? false : "md"}
            fullWidth={scheduledData && scheduledData.length !== 1}
            PaperProps={{
                className: "dialog-paper",
                ...paperStyle,

            }}
        >
            {/* Header */}
            <Box className="youtube-header">
                <Box className="header-content">
                    <Avatar className="header-avatar">
                        <PublishedWithChangesIcon />
                    </Avatar>
                    <Typography variant="h5" className="youtubeText">
                        Scheduled videos published
                    </Typography>
                </Box>
                <IconButton
                    onClick={onClose}
                    className="close-button"
                >
                    <CloseIcon />
                </IconButton>
            </Box>
            <Divider className="ytubeDivider" />

            {/* Content */}
            <Box className="dialog-content">
                <Grid container spacing={3} wrap="wrap" p={2}>
                    {scheduledData && scheduledData.length > 0 ? (
                        scheduledData.map((dataDetails: any, index: number) => (
                            <Grid
                                item
                                xs={12}
                                md={scheduledData.length === 1 ? 12 : scheduledData.length > 5 ? 6 : 6}
                                lg={scheduledData.length === 1 ? 12 : scheduledData.length > 5 ? 4 : 6}
                                key={index}
                                className="body-content"
                            >
                                <Card className="video-card">
                                    {/* Video Thumbnail */}
                                    <Box className="thumbnail-container">
                                        <CardMedia
                                            component="img"
                                            height="250"
                                            image={dataDetails.imageurl}
                                            alt={dataDetails.title}
                                            className="video-thumbnail"
                                        />
                                        {/* Status Chip */}
                                        <Chip
                                            label={dataDetails.status}
                                            color={getStatusColor(dataDetails.status)}
                                            icon={<CheckCircleIcon />}
                                            className="status-chip"
                                        />
                                    </Box>
                                    <CardContent className="card-content">
                                        {/* Title */}
                                        <Typography
                                            variant="h5"
                                            component="h2"
                                            className="youtubeText"
                                        >
                                            {dataDetails.title}
                                        </Typography>
                                        {/* Details Grid */}
                                        <Box className="details-grid">
                                            <Box className="detail-section">
                                                <Box className="detail-header">
                                                    <Avatar className="detail-avatar channel-avatar">
                                                        <VideoLibraryIcon fontSize="small" />
                                                    </Avatar>
                                                    <Typography
                                                        variant="subtitle2"
                                                        className="detail-value"
                                                    >
                                                        Channel ID
                                                    </Typography>
                                                </Box>
                                                <Typography
                                                    variant="body2"
                                                    className="detail-value"
                                                >
                                                    {dataDetails.channelId}
                                                </Typography>
                                            </Box>
                                            {/* YouTube URL */}
                                            <Box className="detail-section">
                                                <Box className="detail-header">
                                                    <Avatar className="detail-avatar youtube-avatar">
                                                        <YouTubeIcon fontSize="small" />
                                                    </Avatar>
                                                    <Typography
                                                        variant="subtitle2"
                                                        className="detail-value"
                                                    >
                                                        YouTube URL
                                                    </Typography>
                                                </Box>
                                                <Box className="url-container">
                                                    <Typography
                                                        variant="body2"
                                                        onClick={() => handleYouTubeClick(dataDetails.youtubeUrl)}
                                                        className="url-text"
                                                    >
                                                        {dataDetails.youtubeUrl}
                                                    </Typography>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => handleYouTubeClick(dataDetails.youtubeUrl)}
                                                        className="launch-button"
                                                    >
                                                        <LaunchIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            </Box>
                                        </Box>
                                        {/* Action Button */}
                                        <Box className="action-button-container">
                                            <Button
                                                variant="contained"
                                                size="large"
                                                startIcon={<YouTubeIcon />}
                                                onClick={() => handleYouTubeClick(dataDetails.youtubeUrl)}
                                                className="youtube-button"
                                            >
                                                Watch on YouTube
                                            </Button>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))
                    ) : (
                        <Box className="no-videos">
                            <Typography variant="h6" color="text.secondary">
                                No scheduled videos found
                            </Typography>
                        </Box>
                    )}
                </Grid>
            </Box>
        </Dialog>
    );
};

export default ScheduledPopup;
